import React, { Component } from "react";
import MatBoards from "../Components/MatBoards/MatBoards";
import Constants from "../Config/Config";
import MattCat from "../Components/Layout/MattCat";

const slides = 4;
const URL =
  Constants.URL.root +
  "/wp-content/themes/justpictureframing/data/products-matt.json";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matBoardsLaoded: false,
      slidesToShow: slides,
      error: null,
    };
  }

  fetchMatBoards = () => {
    var self = this;
    if (this.state.matBoardsLaoded) this.setState({ matBoardsLaoded: false });
    fetch(URL)
      .then((response) => {
        if (!response.ok) {
          throw Error("Network request failed.");
        }
        return response;
      })
      .then((data) => data.json())
      .then(
        (data) => {
          console.log(data);

          if (slides > data.length)
            self.setState({ slidesToShow: data.length });
          else self.setState({ slidesToShow: slides });

          if (self.props.selectedmatBoard.size === 0) {
            //self.selectMatBoard(data[0]);
            data
              .filter((mat) => "1 Window Vertical" === mat["name"])
              .map((mat) => self.selectMatBoard(mat));
          }

          self.dispatchMatBoardsData(data);
          self.setState({ matBoardsLaoded: true });
        },
        (ex) => {
          console.log("error in API for layout");
          this.fetchMatBoards();
        }
      );
  };

  slidesToShow = (count) => {
    slides > count
      ? this.setState({ slidesToShow: count })
      : this.setState({ slidesToShow: slides });
  };

  selectMatBoard = (matBoard) => {
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        selectedmatBoard: matBoard,
      },
    });
  };

  dispatchMatBoardsData(MatBoardData) {
    const data = MatBoardData;
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        matBoards: data,
      },
    });
  }

  componentDidMount() {
    this.fetchMatBoards();
  }

  render() {
    return (
      <div className="row">
        <MattCat {...this.props} slidesToShow={this.slidesToShow} />
        <div className="col-sm-9">
          <div className="tit matt-baord-title">
            <h4>Select the Mat Board layout you would like</h4>
          </div>
          <MatBoards
            {...this.props}
            matBoardsLaoded={this.state.matBoardsLaoded}
            slidesToShow={this.state.slidesToShow}
          />
        </div>
      </div>
    );
  }
}

export default Layout;
